// The "turnstile" variable is defined in the script from Cloudflare.
/* eslint-disable no-undef */
export async function waitForTurnstileLoaded(delay) {
  return new Promise((resolve, reject) => {
    if (typeof turnstile !== 'undefined' && turnstile !== null) {
      resolve(turnstile)
    } else {
      // delay up to 10 seconds, checking with an increasing backoff.
      if (delay < 10000) {
        console.log('delaying ' + delay)

        setTimeout(async function() {
          resolve(await waitForTurnstileLoaded(delay * 2))
        }, delay)

      } else {
        reject('Cloudflare Turnstile service did not load')
      }
    }
  })
}
